import { getAppHead } from '@/services/head.js';

export default function ({ app }) {
  const dynamicHead = getAppHead();

  app.head = {
    ...app.head,
    ...dynamicHead,
    meta: [...(app.head?.meta || []), ...(dynamicHead.meta || [])],
    link: [...(app.head?.link || []), ...(dynamicHead.link || [])],
  };
}
